<template>
      <CChartLine
        :datasets="defaultDatasets"
        :options="defaultOptions1"
        :labels="this.$parent.MemberDepositChartLabel"
      />
</template>
<style>
.c-chartjs-tooltip top{
    margin-top:-60px !important;
}
</style>
<script>
import { CChartLine } from '@coreui/coreui-vue-chartjs'
import { getColor, hexToRgba } from '@coreui/coreui/dist/js/coreui-utilities'
import { mapGetters } from 'vuex'

export default {
    name: 'MemberDepositChart',
    components: {
        CChartLine
    },
    computed: {
        ...mapGetters('Language', ['getLanguage']),
        defaultDatasets() {
            const brandSuccess = getColor('success') || '#4dbd74'
            const brandDanger = getColor('danger') || '#f86c6b'
            const brandBonus = getColor('#7800b6') || '#7800b6'
            const brandWarning = getColor('warning') || '#f9b115'
            const brandInfo = getColor('primary') || '#20a8d8'
            const data1 = [14, 15, 15, 20, 5, 30, 10, 20, 15, 12, 20, 5, 7, 10, 15, 10, 15, 20, 40, 50, 70, 40, 20, 15, 15, 10, 15, 20, 40, 50, 70, 40, 20, 15]
            return [
                {
                    label: this.getLanguage['DB']['MDP'],
                    backgroundColor: hexToRgba(brandSuccess, 10),
                    borderColor: brandSuccess,
                    pointHoverBackgroundColor: brandSuccess,
                    borderWidth: 2,
                    data: this.$parent.bool_isShowDeposit ? this.$parent.MemberDepositChartData : []
                },
                {
                    label: this.getLanguage['DB']['MW'],
                    backgroundColor: hexToRgba(brandDanger, 10),
                    borderColor: brandDanger,
                    pointHoverBackgroundColor: brandDanger,
                    borderWidth: 2,
                    data: this.$parent.bool_isShowWithdraw ? this.$parent.MemberWithdrawChartData : []
                },
                {
                    label: this.getLanguage['DB']['MBNS'],
                    backgroundColor: hexToRgba(brandBonus, 10),
                    borderColor: brandBonus,
                    pointHoverBackgroundColor: brandBonus,
                    borderWidth: 2,
                    data: this.$parent.bool_isShowBonus ? this.$parent.MemberBonusChartData : []
                },

                {
                    label: 'Member Online',
                    backgroundColor: hexToRgba(brandInfo, 10),
                    borderColor: brandInfo,
                    pointHoverBackgroundColor: brandInfo,
                    borderWidth: 2,
                    data: this.$parent.bool_isShowOnline ? data1 : []
                },
                {
                    label: this.getLanguage['DB']['NRG'],
                    backgroundColor: hexToRgba(brandWarning, 10),
                    borderColor: brandWarning,
                    pointHoverBackgroundColor: brandWarning,
                    borderWidth: 2,
                    data: this.$parent.bool_isShowRegister ? this.$parent.MemberRegisterChartData : []
                },
            ]
        },
        defaultOptions1 () {
            return {
                maintainAspectRatio: false,
                legend: {
                    display: false,
                    onClick: function (e, legendItem) {
                        //console.log(legendItem)
                        //var index = legendItem.datasetIndex;
                        //var ci = this.chart;
                        //var alreadyHidden = (ci.getDatasetMeta(index).hidden === null) ? false : ci.getDatasetMeta(index).hidden;
                        ////console.log(ci, ci.getDatasetMeta, alreadyHidden, ci.data);

                        //ci.data.datasets.forEach(function (e, i) {
                        //    var meta = ci.getDatasetMeta(i);

                        //    if (i !== index) {
                        //        if (!alreadyHidden) {
                        //            meta.hidden = meta.hidden === null ? !meta.hidden : null;
                        //        } else if (meta.hidden === null) {
                        //            meta.hidden = true;
                        //        }
                        //    } else if (i === index) {
                        //        meta.hidden = null;
                        //    }
                        //});

                        //ci.update();
                    },
                },
                scales: {
                    xAxes: [{
                        gridLines: {
                            drawOnChartArea: false
                        }
                    }],
                    yAxes: [{
                        ticks: {
                            beginAtZero: true,
                            maxTicksLimit: 10,
                            stepSize: Math.ceil(this.a / 5),
                            max: this.a
                        },
                        gridLines: {
                            display: true
                        }
                    }]
                },
                elements: {
                    point: {
                        radius: 0,
                        hitRadius: 10,
                        hoverRadius: 4,
                        hoverBorderWidth: 3
                    }
                }
            }
        }
    },
}
</script>



// WEBPACK FOOTER //
// src/components/Chart/MemberChart.vue